import { render } from "./TheFooter.vue?vue&type=template&id=370f8120&scoped=true"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=370f8120&scoped=true&lang=css"

import exportComponent from "C:\\Users\\knhmb\\Documents\\Khalid\\Job\\MarvelConnect Technology\\Projects\\One Shop Online Shopping\\one-shop-online-shopping\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370f8120"]])

export default __exports__